import React, { useState } from 'react';
import { Key } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Componente discreto para acesso master
 * Aparece como um pequeno ícone de chave no canto
 * Ao clicar, abre um campo para digitar a senha master
 */
const MasterAccess = ({ produto, slug, onSuccess }) => {
  const [showInput, setShowInput] = useState(false);
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const res = await fetch(`${API_URL}/api/admin/master-access/${produto}/${slug}`, {
        method: 'POST',
        headers: {
          'X-Admin-Key': password
        }
      });

      const data = await res.json();

      if (data.success) {
        setMessage('✅ Acesso liberado!');
        localStorage.setItem('master_token', password);
        if (onSuccess) {
          setTimeout(() => onSuccess(), 1000);
        }
      } else {
        setMessage('❌ ' + (data.message || 'Senha incorreta'));
      }
    } catch (e) {
      setMessage('❌ Erro ao verificar');
    } finally {
      setLoading(false);
    }
  };

  // Verificar se já tem token salvo
  const savedToken = localStorage.getItem('master_token');

  return (
    <div className="fixed bottom-20 right-4 z-50">
      {!showInput ? (
        <button
          onClick={() => setShowInput(true)}
          className="w-10 h-10 bg-slate-800 hover:bg-slate-700 rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-110"
          title="Acesso Master (Admin)"
        >
          <Key size={18} className="text-amber-400" />
        </button>
      ) : (
        <form 
          onSubmit={handleSubmit}
          className="bg-white rounded-lg shadow-xl border border-slate-200 p-3 w-64"
        >
          <div className="flex items-center gap-2 mb-2">
            <Key size={14} className="text-slate-400" />
            <span className="text-xs text-slate-500">Acesso Master</span>
            <button 
              type="button"
              onClick={() => setShowInput(false)}
              className="ml-auto text-slate-400 hover:text-slate-600"
            >
              ✕
            </button>
          </div>
          
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Senha master"
            className="w-full px-3 py-2 text-sm border border-slate-200 rounded focus:outline-none focus:border-blue-500"
            autoFocus
          />
          
          <button
            type="submit"
            disabled={loading || !password}
            className="w-full mt-2 px-3 py-2 bg-slate-800 text-white text-sm rounded hover:bg-slate-700 disabled:opacity-50"
          >
            {loading ? 'Verificando...' : 'Liberar Acesso'}
          </button>
          
          {message && (
            <p className={`text-xs mt-2 ${message.includes('✅') ? 'text-green-600' : 'text-red-600'}`}>
              {message}
            </p>
          )}
          
          {savedToken && (
            <p className="text-xs text-slate-400 mt-2">
              Token salvo detectado
            </p>
          )}
        </form>
      )}
    </div>
  );
};

export default MasterAccess;
